<template>
  <section class="mr-3 w-full max-w-lg pb-6 pt-0 sm:pt-6 xs:mr-0">
    <ontick-card class="w-full" v-if="investment_statistic">
      <h3
        class="text-xl font-bold text-ontick-steel-900 dark:text-gray-300 sm:text-3xl"
      >
        Estatísticas
      </h3>
      <ul
        class="w-full space-y-1 pt-4 text-sm text-ontick-steel-900 dark:text-gray-400 xl:space-y-3"
      >
        <li class="flex items-center justify-between">
          <span> Resultado $: </span>
          <span
            :class="
              investment_statistic.net_profit_loss < 0
                ? 'text-ontick-red-600 dark:text-ontick-red-500'
                : investment_statistic.net_profit_loss == 0
                ? 'text-ontick-steel-900 dark:text-gray-300'
                : 'text-ontick-green-700 dark:text-ontick-green-500'
            "
            >{{ investment_statistic.net_profit_loss | currency }}</span
          >
        </li>

        <li class="flex items-center justify-between">
          <span> Lucro Bruto: </span>
          <span :class="statusColor(investment_statistic.gross_profit)">{{
            investment_statistic.gross_profit | currency
          }}</span>
        </li>
        <li class="flex items-center justify-between">
          <span> Perda Bruta: </span>
          <span :class="statusColor(investment_statistic.gross_loss)">{{
            investment_statistic.gross_loss | currency
          }}</span>
        </li>

        <li class="flex items-center justify-between">
          <span> Taxa de Acerto: </span>
          <span :class="winRatioColor(investment_statistic.win_ratio)"
            >{{ investment_statistic.win_ratio.toFixed(2) }}%</span
          >
        </li>

        <li class="flex items-center justify-between">
          <span> Nº Operações: </span>
          <span>{{ investment_statistic.num_trades }}</span>
        </li>
        <li class="flex items-center justify-between">
          <span> Nº Ganhos: </span>
          <span>{{ investment_statistic.num_winners }}</span>
        </li>
        <li class="flex items-center justify-between">
          <span> Nº de Perdas: </span>
          <span>{{ investment_statistic.num_losers }}</span>
        </li>

        <li class="flex items-center justify-between">
          <span> Nº de Compras: </span>
          <span>{{ investment_statistic.num_buys }}</span>
        </li>

        <li class="flex items-center justify-between">
          <span> Nº de Vendas: </span>
          <span>{{ investment_statistic.num_sells }}</span>
        </li>
        <li class="flex items-center justify-between">
          <span> Fator de Lucro: </span>
          <span
            v-show="investment_statistic.profit_factor > 0"
            :class="
              investment_statistic.profit_factor > 1
                ? 'text-ontick-green-700 dark:text-ontick-green-500'
                : 'text-ontick-red-600 dark:text-ontick-red-500'
            "
            >{{ investment_statistic.profit_factor }}x</span
          >

          <span
            v-show="investment_statistic.profit_factor == 0"
            class="float-right text-ontick-steel-900 dark:text-gray-400"
            >{{ investment_statistic.profit_factor }}x</span
          >
        </li>

        <li class="flex items-center justify-between">
          <span> Ganho Médio: </span>
          <span :class="statusColor(investment_statistic.average_win)">{{
            investment_statistic.average_win | currency
          }}</span>
        </li>

        <li class="flex items-center justify-between">
          <span> Perda Média: </span>
          <span :class="statusColor(investment_statistic.average_loss)">{{
            investment_statistic.average_loss | currency
          }}</span>
        </li>

        <li class="flex items-center justify-between">
          <span> Expectância: </span>
          <span :class="statusColor(investment_statistic.expectancy)">{{
            investment_statistic.expectancy | currency
          }}</span>
        </li>

        <li class="flex items-center justify-between">
          <span> RRR Média: </span>
          <span
            v-show="investment_statistic.avg_rrr > 0"
            :class="
              investment_statistic.avg_rrr > 1
                ? 'text-ontick-green-700 dark:text-ontick-green-500'
                : 'text-ontick-red-600 dark:text-ontick-red-500'
            "
            >1:{{ investment_statistic.avg_rrr }}</span
          >
          <span
            v-show="investment_statistic.avg_rrr == null"
            class="float-right text-ontick-steel-900 dark:text-gray-400"
          >
            -
          </span>
        </li>
      </ul>
    </ontick-card>
    <!-- <ontick-card class="pt-3 h-full" v-if="investment_statistic">
      <ontick-text class="font-bold" size="xl">Taxa de acerto</ontick-text>
      <v-chart
        autoresize
        :options="chartPie(investment_statistic.win_ratio)"
      ></v-chart>
    </ontick-card> -->
  </section>
</template>

<script>
import ECharts from "@/app/shared/components/chart/echarts";

export default {
  name: "cardStrategy",

  components: {
    "v-chart": ECharts,
  },

  props: {
    investment_statistic: {
      type: Object,
      default: null,
    },
  },
  methods: {
    winRatioColor(value) {
      let color;

      if (value > 0 && value < 50) {
        color = "dark:text-ontick-red-500 text-ontick-red-600";
      } else if (value >= 50) {
        color = "dark:text-ontick-green-500 text-ontick-green-700";
      } else if (value == 0) {
        color = "dark:text-gray-400 text-ontick-steel-900";
      }

      return color;
    },

    statusColor(value) {
      let color;

      if (value < 0) {
        color = "dark:text-ontick-red-500 text-ontick-red-600";
      } else if (value === 0) {
        color = "dark:text-gray-400 text-ontick-carbon-900";
      } else {
        color = "dark:text-ontick-green-500 text-ontick-green-700";
      }

      return color;
    },

    chartPie(value) {
      let win_ratio = 0;
      let win_ratio_loss = 0;

      if (value) {
        win_ratio = value.toFixed(2);
        win_ratio_loss = (100 - value).toFixed(2);
      } else {
        win_ratio = 0;
        win_ratio_loss = 0;
      }

      let option = {
        tooltip: {
          show: false,
          trigger: "item",
          fontFamily: "Poppins",
          formatter: function (name) {
            return name.name + " " + name.value + "%";
          },
        },
        legend: {
          show: true,
          top: "90%",
          left: "center",
          textStyle: {
            color: "#f4f4f4",
            fontFamily: "Poppins",
          },
        },
        grid: {
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          containLabel: false,
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 6,
              borderColor: "#202a37",
              borderWidth: 2,
              color: function (params) {
                let color_selected = "RGBA(107,114,128,08)";
                let rgba = { g: 0, r: 0, b: 0, y: 0 };

                if (params.data.name == "Ganho" && value > 0) {
                  color_selected = "rgba(25, 214, 132, 0.8)";
                  rgba.g = 0;
                  rgba.r = 0;
                  rgba.b = 0;
                  rgba.y = 1;
                } else if (params.data.name == "Ganho" && value == 0) {
                  color_selected = "RGBA(107,114,128,08)";
                  rgba.g = 0;
                  rgba.r = 0;
                  rgba.b = 0;
                  rgba.y = 1;
                } else if (params.data.name == "Perda" && value > 0) {
                  color_selected = "rgba(235, 77, 75, 0.8)";
                  rgba.g = 0;
                  rgba.r = 1;
                  rgba.b = 0;
                  rgba.y = 0;
                } else if (params.data.name == "Perda" && value == 0) {
                  color_selected = "RGBA(107,114,128,08)";
                  rgba.g = 0;
                  rgba.r = 1;
                  rgba.b = 0;
                  rgba.y = 0;
                }
                return new ECharts.graphic.LinearGradient(
                  rgba.g,
                  rgba.r,
                  rgba.b,
                  rgba.y,
                  [
                    { offset: 0, color: color_selected },

                    { offset: 1, color: "rgba(32, 42, 55, 1)" },
                  ]
                );
              },
            },
            label: {
              show: true,
              position: "center",
              fontSize: 25,
              fontFamily: "Poppins",
              color: "#f4f4f4",
              formatter: function () {
                return `${win_ratio}%`;
              },
            },

            emphasis: {
              show: false,
              label: { show: false },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: win_ratio_loss, name: "Perda" },
              { value: win_ratio, name: "Ganho" },
            ],
          },
        ],
      };

      return option;
    },
  },
};
</script>

<style scoped></style>
